import { render, staticRenderFns } from "./RecargoDetalle.vue?vue&type=template&id=ff1852a8"
import script from "./RecargoDetalle.vue?vue&type=script&lang=js"
export * from "./RecargoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports